import qs from 'qs'
import _$ from '../../../static/js/api/getdata'
import {
  ifSearchPage, getLanguage, isClient, ifHasAuth, formatBytes,
} from '../../../static/js/util/util'
import { openUrlInside, openUrlOutside } from '@filez/js-2-native'


const DOC_PERVIEW_PATH = {
  base_path: '/v', // 基础预览地址
  file_preview: '/approve/preview', // 正常文件预览界面
  ver_preview: 'preview/history', // 版本预览界面
}

class Preview {
  constructor({
    data, fileList, searchParam, selfOpen, type, vm,
  }) {
    this.data = data
    this.fileList = fileList
    this.searchParam = searchParam
    this.selfOpen = selfOpen
    this.type = type
    this.vm = vm
    this.goPreviewPage()
  }

  deletedToast(errorInfo, contextParma) {
    const context = contextParma
    if (errorInfo.state === 404
      && errorInfo.code === 'source not found') {
      const { name: currentRootName } = window.Router.currentRoute
      if (currentRootName.includes('recent') || currentRootName.includes('favorite')) {
        context.showTips(context.$t('该文件/文件夹已被删除，无法进行操作'), 'warn')
      } else {
        context.toastInfo = {
          info: `<span>${context.$t('该文件/文件夹已被删除，无法进行操作')}</span>`,
          tipsType: 'notAutoClose',
          className: 'toast-deleted',
        }
        context.toastSwitch = true
      }
    } else {
      this.goPreviewPage()
    }
  }

  checkFileLimit() { // 交验文件大小是否超限
    return new Promise(() => {
      const { neid, nsid, access_mode: accessMode } = this.data
      const currentData = this.data
      const context = this.vm
      _$.getData('previewFileLimit', { neid, nsid }).then(({ data }) => {
        const checkData = data
        const { checkSizeResult, previewSizeLimit } = checkData
        if (data && !checkSizeResult) { // 已超限
          const limitSize = formatBytes(previewSizeLimit)
          if (ifHasAuth(accessMode, 'download')) {
            // 有下载能力
            const obj = {
              content: context.$t('该文档大小超过{n}暂不支持在线预览', { n: limitSize }),
            }
            if (isClient()) {
              obj.confirmButton = context.$t('本地打开')
              obj.cb = () => {
                context.localEdit()
              }
            }
            context.confirmData.datalist.dialogPreviewOverSize = {
              ...context.confirmData.datalist.dialogPreviewOverSize,
              ...obj,
              cb() {
                context.confirmData.datalist.dialogPreviewOverSize.callback(currentData)
              },
            }
          } else {
            context.confirmData.datalist.dialogPreviewOverSize = {
              ...context.confirmData.datalist.dialogPreviewOverSize,
              content: context.$t('该文档大小超过{n}暂不支持在线预览', { n: limitSize }),
              subContent: `${context.$t('为了提供稳定的预览体验，目前仅支持下载查看')} ${context.$t('如果您没有下载权限，请联系文件授权者或者系统管理员')}</p>`,
              singleButton: true,
              confirmButton: context.$t('知道了'),
              cb() {
              },
            }
          }
          context.setCmd({ name: 'dialogPreviewOverSize', operateType: '2' })
          return
        }
        this.goPreviewPage()
      }).catch((e) => { // 除了大小限制、已删除的异常都走到预览页面
        if (e.response.data) {
          this.deletedToast(e.response.data, context)
        } else {
          this.goPreviewPage()
        }
      })
    })
  }

  goPreviewPage() {
    let other = ''
    let from = this.data.path_type
    const {
      neid, mime_type: mineType, nsid, path_type: pathType, pid,
    } = this.data
    const { name: currentRootName } = window.Router.currentRoute
    const shareMap = {
      share_out: 'myshare',
      share_in: 'shared',
    }
    from = shareMap[from] === undefined ? from : shareMap[from] // 共享的需要转换
    const { searchParam } = this
    if (currentRootName === 'recent') {
      from = 'recent'
      searchParam.neid_dir = pid
      searchParam.path_type = pathType
    } else if (currentRootName === 'favorite') {
      searchParam.path_type = pathType
      from = 'favorite'
    } else {
      searchParam.neid_dir = pid // neid_dir 为上级目录的neid
      searchParam.path_type = pathType
    }
    other = JSON.stringify(searchParam)
    const paramObj = {
      from,
      language: getLanguage(),
      other,
    }
    let urlswitch = `${DOC_PERVIEW_PATH.base_path}/${DOC_PERVIEW_PATH[this.type]}`
    if (this.type === 'file_preview') {
      delete paramObj.from
      urlswitch = `${urlswitch}/${from}`
    }
    const previewUrl = `${urlswitch}/${neid}/${nsid}?${qs.stringify(paramObj)}`
    const { href } = this.vm.$router.resolve({
      name: 'approveBox',
      params: {
        from,
        neid,
        nsid,
      },
      query: paramObj,
    })
    const clientToWebType = ['dwg', 'video', 'audio']
    this.previewUrl = href
    if (mineType !== '') {
      if (clientToWebType.filter((item) => mineType.indexOf(item) > -1).length > 0) {
        this.getClientoRWebUrl({ inside: false, isSelf: this.selfOpen }) // 客户端通过web端打开
      } else {
        this.getClientoRWebUrl({ inside: true, isSelf: this.selfOpen }) // 客户端在内部打开
      }
    }
  }

  getClientoRWebUrl({ inside = true, isSelf = false }) {
    // 设置跳转对象
    const params = {}
    const baseUrl = this.previewUrl
    params.url = `${window.location.protocol}//${window.location.host}${baseUrl}`

    // 判断跳转
    if (isClient()) {
      if (inside) {
        params.width = '800'
        params.height = '600'
        params.fullscreen = 'false'
        params.loadingStyle = 'carousel'
        openUrlInside(params)
      } else {
        openUrlOutside(params)
      }
    } else if (isSelf) {
      window.location.href = params.url
    } else {
      window.open(this.previewUrl, '_blank')
    }
  }
}

export default Preview
